export const API = {  
    UPDATE_REP_NOTES: {
      path: '/v1/Schedule/update-rep-notes',
      method: 'POST',
    },
    SEND_FOLLOWUP_EMAIL: {
      path: '/v1/Schedule//send-followup-email-to-doctor',
      method: 'POST',
    },    
};